import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=95444822"
import script from "./UserRow.vue?vue&type=script&lang=js"
export * from "./UserRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports